import type {
  ButtonHTMLAttributes,
  InputHTMLAttributes,
  ReactNode,
  SelectHTMLAttributes,
  TextareaHTMLAttributes,
} from 'react';
import { forwardRef } from 'react';

export const Button = forwardRef<HTMLButtonElement, ButtonHTMLAttributes<HTMLButtonElement>>(
  function Button({ className = '', ...props }, ref) {
    return <button className={`ui-button ${className}`.trim()} ref={ref} {...props} />;
  },
);

export const IconButton = forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement> & { label: string; children: ReactNode }
>(function IconButton({ label, children, className = '', ...props }, ref) {
  return (
    <Button
      aria-label={label}
      className={`ui-icon-button ${className}`.trim()}
      ref={ref}
      title={props.title ?? label}
      {...props}
    >
      {children}
    </Button>
  );
});

export function Input(props: InputHTMLAttributes<HTMLInputElement>) {
  return <input {...props} />;
}

export function Select(props: SelectHTMLAttributes<HTMLSelectElement>) {
  return <select {...props} />;
}

export function Textarea(props: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <textarea {...props} />;
}

export function PopoutMenu({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div aria-label={label} className="ui-popout-menu" role="menu">
      {children}
    </div>
  );
}
